import { RollBase } from 'dice-roller-parser';
import { PointData } from 'pixi.js';
import { Entity } from 'src/extensions';
import { MouseType } from 'src/graphics/mouse';

/* The API used by YJS for document synchronization must not be changed willy nilly. */

export enum C {
    All = 'All',
    Ref = 'Ref',
    AI = 'AI',
    Whisper = 'Whisper'
}

export enum L {
    Fog = 'f',
    Mapping = 'm',
    Uploads = 'u',
    Graffiti = 'g',
    Tokens = 't',
}

export enum R {
    Chat = 'c',
    Attendees = 'a',
    Settings = 's',
    Lasers = 'p',
    Layers = 'l',
    LayerPolygons = 'la',
    LayerLines = 'll',
    Images = 'i',
    Tokens = 't',
    ImageAssets = 'ia',
    TokenAssets = 'ta',
    Strokes = 'st',
}

export interface LayerDelta {
    d: boolean; /* direction */
    p: number[]; /* path */
}

export interface ILayerSettings {
    id: string;
    fillColor: string;
    lineColor: string;
    lineWidth: number;
    dashLength: number;
    lineAmplitude: number;
    gridAmplitude: number;
    gridColor: string;
    gridWidth: number;
    shadowLength: number;
    shadowColor: string;
}

export interface IUserAwareness {
    name: string;
    color: string;
}

export interface IAttendee extends Entity {
    name: string;
    color: string;
    referee: boolean;
    view: {
        position: PointData,
        scale: number
    };
}

export interface IMessage {
    date: number;
    accountId: string;
    text: string;
    channel: string;
    receiverId: string;
    rolls?: RollBase[] | any;
}

export interface IRoomSettings {
    [key: string]: any;
    counter: number;
    freedom: boolean;
}

export interface IAccountSettings {
    [key: string]: any;
    name: string;
    color: string;
    chat: {
        [key: string]: any;
        alwaysOpen: boolean;
        autoscroll: boolean;
        keepOpenAfterSend: boolean;
        width: number;
        zoom: number;
    };
    dicemacros: string[];
    activeLayerId: L;
    erasing: boolean;
    snapping: boolean;
    alignment: number;
    mousetype: MouseType;
    highquality: boolean | undefined;
    swapmiddleright: boolean;
    requiredragselect: boolean;
    disableSFX: boolean;
    opaquemacros: boolean;
    openAiKey: string;
    clearDate: number;
}

export interface IRoomAsset {
    id: string;
    name: string;
    uploaderId: string;
}

export interface IImage extends IRoomSprite {
    gridScale: number;
}

export interface IToken extends IRoomSprite {
    assetId: string;
    label: string;
    armor?: number;
    health?: number
    maxhealth?: number;
}

export interface IRoomSprite {
    id: string;
    scale: PointData;
    rotation: number;
    position: PointData;
    visible: boolean;
    locked: boolean;
    selectorId?: string;
}
